<template>
    <UModal
        class="dark"
        prevent-close
        @update:model-value="onUpdateOpen" 
        :model-value="open" 
        :ui="{ width: 'w-full sm:max-w-sm overflow-hidden' }"
    >
        <div class="p-4 space-y-7">
            <div class="flex items-center justify-center bg-gray-950/50 p-4 -m-4 mb-0">
                <h1 class="font-medium text-xs text-gray-400 uppercase">Incoming Call</h1>
            </div>
            <div class="flex-1 flex flex-col items-center justify-center">
                <Avatar 
                    size="3xl"
                    class="mb-4 flex-shrink-0 ring-2 ring-gray-700 bg-gray-200 rounded-lg"
                    :path="customer?.avatar" 
                    :placeholder="[customer?.first_name, customer?.last_name].filter(Boolean).join(' ')" 
                />
                <h2 class="mb-1 font-medium text-xl text-white">
                    {{ customerName }}
                </h2>
                <span class="text-sm text-gray-400 capitalize">
                    {{ customerDemographics }}
                </span>
            </div>
            <div class="w-full flex flex-row-reverse items-center gap-x-4">
                <UButton 
                    @click="onJoin()" 
                    icon="i-ph-phone-duotone"
                    label="Join" 
                    size="lg"  
                    block 
                    class="dark:text-white dark:bg-rose-600 dark:hover:bg-rose-500"
                    :ui="{ block: 'w-auto flex-1' }"
                />
                <UButton 
                    @click="onIgnore()" 
                    icon="i-ph-phone-slash-duotone"
                    label="Ignore" 
                    size="lg"
                    color="gray"
                    block 
                    :ui="{ block: 'w-auto flex-1' }"
                />
            </div>
        </div>
    </UModal>
</template>

<script setup lang="ts">
import type { Customer } from '~/types/customer';

const emit = defineEmits<{
    'update:open': [boolean],
    'join': [void],
    'ignore': [void],
}>()

const props = defineProps<{
    open: boolean,
    customer?: Customer
}>()

const { age } = useNumber()

const customerName = computed(() => {
    if (props.customer) {
        return [props.customer.first_name, props.customer.middle_name, props.customer.last_name].filter(Boolean).join(' ')
    }
})

const customerDemographics = computed(() => {
    if (props.customer) {
        return [props.customer.gender, age(props.customer.birth_date), props.customer.blood_type].filter(Boolean).join(' · ')
    }
})

function onUpdateOpen(open: boolean) {
    if (!open) onIgnore()
}

function onJoin() {
    emit('update:open', false)
    setTimeout(() => emit('join'), 300)
}

function onIgnore() {
    emit('update:open', false)
    setTimeout(() => emit('ignore'), 300)
}
</script>